import { Bell } from "lucide-react";
import { useNotifications } from "@/hooks/use-notifications";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export function NotificationBell() {
  const { items, unread, markAllRead } = useNotifications();

  return (
    <Popover onOpenChange={(o) => o && unread > 0 && markAllRead()}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="relative h-9 w-9 rounded-md border border-lt-border text-lt-cream3 hover:text-foreground"
          aria-label="Notificações"
        >
          <Bell className="h-4 w-4" />
          {unread > 0 && (
            <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-medium text-primary-foreground">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 border-lt-border bg-card p-0">
        <div className="border-b border-lt-border px-4 py-3">
          <h3 className="font-serif text-sm text-foreground">Notificações</h3>
          <p className="text-[11px] text-muted-foreground">
            {items.length === 0 ? "Nada por aqui" : `${items.length} recente${items.length > 1 ? "s" : ""}`}
          </p>
        </div>
        <div className="max-h-80 overflow-y-auto">
          {items.length === 0 ? (
            <div className="px-4 py-8 text-center text-xs text-muted-foreground">
              Você verá aqui quando seus jogos salvos forem premiados.
            </div>
          ) : (
            items.map((n) => (
              <Link
                key={n.id}
                to="/app/jogos"
                className="block border-b border-lt-border/50 px-4 py-3 transition-colors last:border-0 hover:bg-muted/30"
              >
                <div className="flex items-start gap-2">
                  {!n.read_at && <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />}
                  <div className="flex-1">
                    <p className="text-xs font-medium text-foreground">{n.title}</p>
                    <p className="mt-0.5 text-[11px] text-muted-foreground">{n.message}</p>
                    <p className="mt-1 text-[10px] text-muted-foreground/70">
                      {new Date(n.created_at).toLocaleString("pt-BR")}
                    </p>
                  </div>
                </div>
              </Link>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}